<template>
  <v-dialog v-model="isShowing" width="80vw" max-width="1600px">
    <v-card>
      <v-card-title>
        <span class="headline">
          {{ title }}
        </span>
      </v-card-title>
      <v-card-text style="min-height: 72vh;">
        <v-data-table
          :headers="headers"
          :items="list"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.item.from }}</td>
            <td class="text-xs-left">{{ props.item.to }}</td>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click="isShowing = false">閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        { text: '開始IP', value: 'from' },
        { text: '終了IP', value: 'to' },
      ],
    }
  },
  computed: {
    isShowing: {
      get() {
        return this.value
      },
      set(isDisplay) {
        return this.$emit('input', isDisplay)
      },
    },
  },
  methods: {},
}
</script>
